import React, { Component } from 'react';
import {
  Alert,
  Button,
  Card,
  CardTitle,
  CardBody,
  Form,
  FormGroup,
  Input
} from 'reactstrap';

class CreateAccountPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: '',
      formEmail: '',
      formPassword: '',
      formVerifyPassword: '',
      verifyPasswordHasError: false,
      pending: false
    }
  }

  handleEmailInput = (e) => {
    this.setState({
      formEmail: e.target.value,
      errorMessage: ''
    });
  }

  handlePasswordInput = (e) => {
    this.setState({
      formPassword: e.target.value,
      errorMessage: ''
    });
  }

  handleVerifyPasswordInput = (e) => {
    this.setState({
      formVerifyPassword: e.target.value,
      errorMessage: ''
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      errorMessage: '',
      verifyPasswordHasError: false,
      pending: true
    });

    // verify passwords match
    if (this.state.formPassword !== this.state.formVerifyPassword) {
      this.setState({
        verifyPasswordHasError: true,
        errorMessage: 'Passwords do not match',
        pending: false
      });
      return;
    }

    this.props.onCreateAccountAttempt(
      this.state.formEmail,
      this.state.formPassword
    ).catch(e => {
      this.setState({
        errorMessage: e.message || 'Failed to create account. Please try again.',
        pending: false
      });
    });

  }

  render() {

    return (
        <div className="CreateAccountPage full-page d-flex justify-content-center align-items-center flex-column">

          {
            this.props.message && !this.state.errorMessage &&
            <Alert color={this.props.messageType || 'info'}>
              {this.props.message}
            </Alert>
          }

          {
            this.state.errorMessage &&
            <Alert color="danger">
              {this.state.errorMessage}
            </Alert>
          }

          <Card>
            <CardBody>
              <CardTitle className="text-center">Create Account</CardTitle>
              <Form>
                <FormGroup>
                  <Input
                    type="email"
                    placeholder="Email"
                    invalid={this.state.errorMessage.toLowerCase().includes('email')}
                    value={this.state.formEmail}
                    onChange={this.handleEmailInput}
                  />
                </FormGroup>
                <FormGroup>
                  <Input
                    type="password"
                    placeholder="Password"
                    invalid={this.state.errorMessage.toLowerCase().includes('password')}
                    value={this.state.formPassword}
                    onChange={this.handlePasswordInput}
                  />
                </FormGroup>
                <FormGroup>
                  <Input
                    type="password"
                    placeholder="Confirm Password"
                    invalid={this.state.verifyPasswordHasError}
                    value={this.state.formVerifyPassword}
                    onChange={this.handleVerifyPasswordInput}
                  />
                </FormGroup>
                <div className="d-flex mt-4 justify-content-center">
                  <Button
                    color="primary"
                    type="submit"
                    disabled={this.state.pending}
                    onClick={this.handleSubmit}
                  >
                    Create Account
                  </Button>
                </div>
              </Form>

              <div className="mt-4 text-center">
                <div>
                  <button
                    className="btn btn-link btn-sm"
                    onClick={this.props.onShowLoginPage}
                  >
                      Already have an account?
                  </button>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      );
  }
}

export default CreateAccountPage;



// WEBPACK FOOTER //
// ./src/pages/CreateAccountPage.jsx